import "./HomeAdditions.module.css";
import Header from "@/reusable_sections/Header";
import Expansionspecialties from "./sections/Expansionspecialties";
import CieloNido from "./sections/CieloNido";
import Methodology from "./sections/Methodology";
import Faq from "./sections/Faq";
import Consultation, { GnciBooking } from "./sections/Consultation";
import Footer from "@/reusable_sections/Footer";

// Order (owner request Sept 17): booking form first, then the additions we build, then what an addition can include.
// The former Dispatch (hero) section is kept in the project but no longer shown.
export default function HomeAdditionsPage() {
  return <div>
      <Header />
      <GnciBooking service="additions" />
      <CieloNido />
      <Expansionspecialties />
      <Methodology />
      <Faq />
      <Consultation />
      <Footer />
    </div>;
}